import AddIcon from "@mui/icons-material/AddRounded";
import { Button, Stack, Typography } from "@mui/material";
import useDefinedContext from "@entrilia/shared/hooks/useDefinedContext";
import AgentInboxChannelCard from "./AgentInboxChannelCard";
import AgentInboxSettingsContext from "./AgentInboxSettingsContext";
import { createNewChannelAction } from "./editInboxChannelState";

const AgentInboxChannelsSection = () => {
  const { hasEditPermissions, inbox, setEditedChannelState } = useDefinedContext(AgentInboxSettingsContext);

  return (
    <Stack spacing={2}>
      <Stack spacing={1}>
        <Typography variant="subtitle1" sx={{ pt: 2, pb: 1 }}>
          Channels
        </Typography>

        {inbox.channels.length > 0 && (
          <Stack spacing={2}>
            {inbox.channels.map((channel) => (
              <AgentInboxChannelCard key={channel.id} channel={channel} />
            ))}
          </Stack>
        )}

        {hasEditPermissions && (
          <Button
            variant="text"
            color="primary"
            startIcon={<AddIcon />}
            onClick={() => setEditedChannelState(createNewChannelAction())}
            sx={{ width: "fit-content", alignSelf: "center" }}
          >
            Add Channel
          </Button>
        )}
      </Stack>
    </Stack>
  );
};

export default AgentInboxChannelsSection;
